'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PageLink = require('containers/PageLink');

var _PageLink2 = _interopRequireDefault(_PageLink);

var _Hero = require('components/Hero/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _TextBlock = require('./TextBlock');

var _TextBlock2 = _interopRequireDefault(_TextBlock);

var _ImageBlock = require('./ImageBlock');

var _ImageBlock2 = _interopRequireDefault(_ImageBlock);

var _QuoteBlock = require('./QuoteBlock');

var _QuoteBlock2 = _interopRequireDefault(_QuoteBlock);

var _AudioBlock = require('./AudioBlock');

var _AudioBlock2 = _interopRequireDefault(_AudioBlock);

var _VideoBlock = require('./VideoBlock');

var _VideoBlock2 = _interopRequireDefault(_VideoBlock);

var _project = require('./project.css');

var _project2 = _interopRequireDefault(_project);

var _nextProject = require('./nextProject.css');

var _nextProject2 = _interopRequireDefault(_nextProject);

var _projectDetails = require('./projectDetails.css');

var _projectDetails2 = _interopRequireDefault(_projectDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Project = function (_Component) {
  _inherits(Project, _Component);

  function Project() {
    _classCallCheck(this, Project);

    var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this));

    _this.state = {
      finishLoading: false,
      main: {},
      body: {
        blocks: []
      },
      nextCaseStudy: {}
    };
    return _this;
  }

  _createClass(Project, [{
    key: 'fetchData',
    value: function fetchData(slug) {
      var _props = this.props,
          fetchProject = _props.fetchProject,
          fetchProjects = _props.fetchProjects;

      fetchProject(slug);
      fetchProjects();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = 'Work | Soundscape Agency';
      this.fetchData(this.props.routeParams.slug);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.scrollTo(0, 0);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.main !== newProps.main) {
        if (newProps.main !== null) {
          this.setState({
            data: newProps.data,
            main: newProps.main,
            body: newProps.body,
            finishLoading: true
          });

          if (newProps.main.title !== undefined) document.title = newProps.main.title + ' | Soundscape Agency';
        } else {
          this.context.router.push('/');
        }
      }

      if (this.props.nextCaseStudy !== newProps.nextCaseStudy) {
        this.setState({
          nextCaseStudy: newProps.nextCaseStudy
        });
      }

      if (this.props.routeParams.slug !== newProps.routeParams.slug) {
        this.fetchData(newProps.routeParams.slug);
      }
    }
  }, {
    key: 'renderNextProject',
    value: function renderNextProject() {
      var nextCaseStudy = this.state.nextCaseStudy;


      if (nextCaseStudy) {
        return _react2.default.createElement(
          _PageLink2.default,
          {
            className: _nextProject2.default.nextProject,
            style: { backgroundImage: 'url(' + nextCaseStudy.mainImage + ')' },
            to: nextCaseStudy.url
          },
          _react2.default.createElement('div', { className: _nextProject2.default.overlay }),
          _react2.default.createElement(
            'div',
            { className: _nextProject2.default.label },
            'Next case study'
          ),
          _react2.default.createElement(
            'h4',
            { className: _nextProject2.default.title },
            nextCaseStudy.title
          ),
          _react2.default.createElement(
            'h5',
            { className: _nextProject2.default.subtitle },
            nextCaseStudy.subtitle
          )
        );
      }
    }
  }, {
    key: 'renderFields',
    value: function renderFields() {
      var main = this.state.main;

      var fields = main.fields;

      if (main && fields && fields.length) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: _projectDetails2.default.middleLabel },
            'Fields'
          ),
          _react2.default.createElement(
            'div',
            { className: _projectDetails2.default.holder },
            _react2.default.createElement(
              'div',
              { className: _projectDetails2.default.half },
              fields.map(function (item, index) {
                if (index < 3) {
                  return _react2.default.createElement(
                    'h4',
                    { className: _projectDetails2.default.field, key: 'field_' + index },
                    item
                  );
                }
              })
            ),
            _react2.default.createElement(
              'div',
              { className: _projectDetails2.default.half },
              main.fields.map(function (item, index) {
                if (index >= 3) {
                  return _react2.default.createElement(
                    'h4',
                    { className: _projectDetails2.default.field, key: 'field_' + index },
                    item
                  );
                }
              })
            )
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          main = _state.main,
          body = _state.body;


      return _react2.default.createElement(
        'div',
        { className: _project2.default.work },
        _react2.default.createElement(_Hero2.default, {
          isProject: true,
          title: main.title,
          subtitle: main.subtitle,
          strap: main.strap
        }),
        _react2.default.createElement(
          'section',
          { className: _project2.default.blocks },
          _react2.default.createElement(
            'div',
            { className: _project2.default.imgBlock },
            _react2.default.createElement(
              'div',
              { className: _project2.default.inner },
              _react2.default.createElement('img', { src: main.mainImage, alt: main.title })
            )
          ),
          body.blocks.map(function (item, index) {
            switch (item.type) {
              case 'text':
                return _react2.default.createElement(_TextBlock2.default, { key: 'content-block_' + index, copy: item.copy });
              case 'image':
                return _react2.default.createElement(_ImageBlock2.default, { key: 'content-block_' + index, image: item.image });
              case 'quote':
                return _react2.default.createElement(_QuoteBlock2.default, { key: 'content-block_' + index, caption: item.caption, image: item.image, role: item.role, author: item.author });
              case 'audio':
                return _react2.default.createElement(_AudioBlock2.default, { key: 'content-block_' + index, files: item.files });
              case 'video':
                return _react2.default.createElement(_VideoBlock2.default, { key: 'content-block_' + index, video: item.video, poster: item.poster });
              default:
                return;
            }
          })
        ),
        _react2.default.createElement(
          'section',
          { className: _projectDetails2.default.projectDetails },
          _react2.default.createElement(
            'div',
            { className: _project2.default.innerTiny },
            _react2.default.createElement(
              'div',
              { className: _projectDetails2.default.holder },
              _react2.default.createElement(
                'div',
                { className: _projectDetails2.default.half },
                _react2.default.createElement(
                  'div',
                  { className: _projectDetails2.default.label },
                  'Client'
                ),
                _react2.default.createElement(
                  'h3',
                  { className: _projectDetails2.default.title },
                  main.client
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _projectDetails2.default.half },
                _react2.default.createElement(
                  'div',
                  { className: _projectDetails2.default.label },
                  'Year'
                ),
                _react2.default.createElement(
                  'h3',
                  { className: _projectDetails2.default.title },
                  main.year
                )
              )
            ),
            this.renderFields()
          )
        ),
        this.renderNextProject()
      );
    }
  }]);

  return Project;
}(_react.Component);

exports.default = Project;


Project.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/Project.js
// module id = 329
// module chunks = 1